import { ChatRoom } from './components/ChatRoom.js';

export function App() {
    return <ChatRoom />;
}
